import React from 'react'
import './Dialog.css';

export function DialogOk({ display, title, description, ok, color }) {

    if (!display) {
        return <></>;
    }
    const hrlineStyle = {
        color: color
    };
    return (
        <div className="overlay">
            <div className="dialog">
                <div className="dialog_content">
                    <h2 className="dialog_title">{title}</h2>
                    <hr className="hrline" style={hrlineStyle} />
                    <h2 className="line"> </h2>
                    <p className="dialog_description">{description}</p>
                </div>
                <hr className="hr" />
                <div className="dialog_footer">
                    <button onClick={ok} className="dialog_btn">Ok</button>
                </div>
            </div>
        </div>
    )
}

export default DialogOk;